import * as Yup from "yup";
import { useTranslation } from "react-i18next";
const useAccountTypeSchema = () => {
  const { t } = useTranslation();
  return Yup.object().shape({
    accountType: Yup.object().required(t("account_type_required")).nullable(),
  });
};

export default useAccountTypeSchema;
